import { render, staticRenderFns } from "./UserMeasureSituation.vue?vue&type=template&id=242a2090&scoped=true&"
import script from "./UserMeasureSituation.vue?vue&type=script&lang=js&"
export * from "./UserMeasureSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a2090",
  null
  
)

export default component.exports